export default __webpack_public_path__ + "static/hero-video-28c5f39a1eeed1970fa55ce1ffa735fd.mp4";